import { Container, Row, Col } from "react-bootstrap";
import logo from "../assets/img/logo.svg";
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/github_icon.svg";
import navIcon3 from "../assets/img/nav-icon3.svg";

export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          <Col size={12} sm={6}>
            {/* Your text goes here */}
            <p>Pushkar Shinalkar || Product Engineer</p>
          </Col>
          <Col size={12} sm={6} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
            {/* Social icons go here */}

            <div className="social-icon">
              <a href="https://www.linkedin.com/in/pushkar-shinalkar-63ab4917b/"><img src={navIcon1} alt="" /></a>
            </div>
            {/* <div className="social-icon">
              <a href="https://github.com/pushkarshinalkar"><img style={{ width: 15 }} src={navIcon2} alt="" /></a>
            </div>
            <div className="social-icon">
              <a href="tg://resolve?domain=${pushkarshinalkar}"><img style={{ width: 25 }} src={navIcon3} alt="" /></a>
            </div> */}
          </Col>
        </Row>
      </Container>
    </footer>
  );
};
